import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/library/programs")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb() {
      return {
        href: "/library/programs",
        labelTranslationKey: "programsPage.breadcrumb",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
